module.exports = __webpack_public_path__ + "media/images/icon-beginner-349865284aaca47db36c1dee25194cec.svg";